import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { cleanToken } from 'utilities/AuthService';
import { LOGIN } from 'navigator/links';
import { Logout } from 'api/security-endpoint';

function LogoutPage(): JSX.Element {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
  
    useEffect(() => {
        const logoutOfValidationPortalApi = async () => {
            try {
                setLoading(true);
                const logoutResponse = await Logout();
                if (!logoutResponse.logoutSuccessful) {
                    console.error('Logout not successful:', logoutResponse);
                }
            } catch (error) {
                console.error('Exception during logout:', error);
            }
            finally {
                cleanToken();
                setTimeout(() => { setLoading(false); navigate(LOGIN); }, 1000);
            }
        };
        logoutOfValidationPortalApi()
    }, []);
  
    return (
      <div>
        <>{loading ? <div>Loading...</div> : <></>}</>
        Logging out of Validation Portal...
      </div>
    );
}

export default LogoutPage;
